import type { IMarketIndex } from '@types'
import Api from '@api/Api'

export default abstract class MarketsAdapter {
  public static async getIndices(): Promise<Array<IMarketIndex>> {
    return Api.get<Array<IMarketIndex>>('/indices')
  }
}
